import { ArrowLeft } from "lucide-react";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import styles from "./editor-header.module.css";

export function EditorHeader({
  eyebrow,
  title,
  backTo,
  backLabel = "Listeye dön",
  actions,
}: {
  eyebrow: string;
  title: string;
  backTo?: string;
  backLabel?: string;
  actions?: ReactNode;
}) {
  return (
    <header className={styles.header}>
      <div className={styles.identity}>
        {backTo ? <Link className={styles.back} to={backTo} aria-label={backLabel}>
          <ArrowLeft size={18} />
        </Link> : null}
        <div className={styles.copy}>
          <span>{eyebrow}</span>
          <h1>{title}</h1>
        </div>
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </header>
  );
}
